import fromUnixTime from 'date-fns/fromUnixTime';

/**
 * @deprecated This helper is deprecated. Use the @dealroadshow/uikit-date-time class with appropriate methods instead.
 * @param {number} timestamp
 */
export const getDateFromUnixTime = (timestamp: number): Date => fromUnixTime(timestamp);

export default getDateFromUnixTime;
